import axios from "axios";
import { serverURL,headeroption,headeroptionupload } from "../http-common";

class AirconhistoryService {
  getallAirconhistory(data) {
    return axios.get(serverURL + "/airconhistory-api?req=smarttableAirconhistory", {
      params: data,
      headers: headeroption,
    })
  }
  getAirconhistory(ah_id) {
    return axios.get(serverURL + "/airconhistory-api?req=getAirconhistory", {
      params: { ah_id: ah_id }, headers: headeroption,
    });
  }
  createAirconhistory(data) {
    return axios.post(serverURL + "/airconhistory-api?req=createAirconhistory", data, {
      headers: headeroption,
    });
  }
  updateAirconhistory(data) {
    return axios.put(serverURL + "/airconhistory-api?req=updateAirconhistory", data, {
      headers: headeroption,
    });
  }
  deleteAirconhistory(ah_id) {
    return axios.delete(serverURL + "/airconhistory-api?req=deleteAirconhistory", { params: { ah_id: ah_id }, headers: headeroption, });
  }
  deleteAll() {
    return axios.delete(serverURL + "/airconhistory-api?req=deleteAirconhistory");
  }
  findByTitle(ah_name) {
    return axios.get(serverURL + "/airconhistory/airconhistory-api?name=" + ah_name);
  }
  upload(ah_id, data) {
    return axios.post(serverURL + "/uploads-api/singlefile?ah_id=" + ah_id, data, { headers: headeroptionupload });
  }
  uploads(ah_id, data) {
    return axios.post(serverURL + "/uploads-api/uploadmultifile?ah_id=" + ah_id, data, { headers: headeroptionupload });
  }
}
export default new AirconhistoryService();
